import React from "react";

/**
 * @typedef {import("react").ReactElement} ReactElement
 */

/**
 * 
 * @param {Object} props
 * @param {ReactElement=} props.icon
 * @param {(string|ReactElement)=} props.instrux
 * @param {"small"=} props.size
 * @param {("desktop"|"mobile")=} props.layout
 * @returns {ReactElement}
 */
function PlaceholderBackground({ icon, instrux, size, layout }) {
  const containerStyle = {
    lineHeight: size === "small" ? 1.2 : 1.4,
    fontSize: layout === "mobile" ? 14 : 16,
  };

  const iconStyle = {
    fontSize: size === "small" ? 24 : 32,
    height: size === "small" ? 20 : 40,
  };

  return (
    <div className="placeholderContainer" style={containerStyle}>
      <div className="contentContainer">
        <div className="iconContainer" style={iconStyle}>
          {icon}
        </div>
        <div className="placeholderText">{instrux}</div>
      </div>
    </div>
  );
}

export default PlaceholderBackground;
